<script setup lang="ts">
import { getCalculatedPricePresentation } from "#shared/lib/price-presentation";
import type { StoreCalculatedPrice } from "@medusajs/types";

const props = defineProps<{
  calculated_price: StoreCalculatedPrice;
}>();
const presentation = computed(() => getCalculatedPricePresentation(props.calculated_price));
</script>

<template>
  <div class="flex gap-3 lg:text-2xl text-base items-center">
    <template
      v-if="
        presentation.oldPrice !== null
      "
    >
      <span class="font-medium" :class="{ 'text-red': presentation.isRed }">{{
        calculated_price.calculated_amount?.toLocaleString("ru-RU", {
          style: "currency",
          currency: "RUB",
          currencyDisplay: "symbol",
          minimumFractionDigits: 0,
        })
      }}</span>
      <span class="line-through text-gray">{{
        presentation.oldPrice?.toLocaleString("ru-RU", {
          style: "currency",
          currency: "RUB",
          currencyDisplay: "symbol",
          minimumFractionDigits: 0,
        })
      }}</span>
    </template>
    <span v-else :class="{ 'text-red': presentation.isRed }">{{
      calculated_price.calculated_amount?.toLocaleString("ru-RU", {
        style: "currency",
        currency: "RUB",
        currencyDisplay: "symbol",
        minimumFractionDigits: 0,
      })
    }}</span>
  </div>
</template>
